export default class GetEntityWorkTypeAssociationByEntityIdAndWorkTypeGroupIdError extends Error {

}
